import React from 'react';
// Note: This export should no longer be required as types are exported from the root index file. This is to support apps that are still using the types from the published /lib folders.
export { BulletListType, BulletIconColors } from './bullet-list.types';
// Add SVG data here when adding additional icons, object name MUST match entry in BulletListType
export var iconData = {
    tick: {
        paths: (React.createElement("path", { d: "M15.06,2.27l-10,10L.94,8,0,8.93,4.67,13.6a.5.5,0,0,0,.4.13c.13,0,.4,0,.4-.13L16,3.07Z", fill: "#000000" })),
    },
    cross: {
        paths: (React.createElement("path", { clipRule: "evenodd", d: "m13.3 2-5.3 5.3-5.3-5.3-.7.7 5.3 5.3-5.3 5.3.7.7 5.3-5.3 5.3 5.3.7-.7-5.3-5.3 5.3-5.3z", fill: "#000000", fillRule: "evenodd" })),
    },
    // need to fill out the remaining bullet list types
    ordered: {
        paths: null,
    },
    standard: {
        paths: null,
    },
};
